import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-time-tracks-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './time-tracks-page.component.html',
  styleUrl: './time-tracks-page.component.css'
})
export class TimeTracksPageComponent {

}
